import type React from "react";
import {useState} from "react";
import {observer} from "mobx-react-lite";
import {IconButton, Tooltip} from "@mui/material";
// The design system's `settings` icon (the gear).
import SettingsIcon from "~/components/icons/svg/SettingIcon.svg?react";
import {useStores} from "~/stores";
import type {m_taxonomy} from "~/services/classes/TaxonomyClasses";
import {TaxonomySettingsDrawer} from "./TaxonomySettingsDrawer";

type TaxonomySettingsButtonProps = {
    /** Undefined while loading: no button until the taxonomy is there. */
    taxonomy?: m_taxonomy.FullSerializer;
};

/** The settings button (Mithra staff only), which opens the taxonomy's settings drawer. */
export const TaxonomySettingsButton: React.FC<TaxonomySettingsButtonProps> = observer(({taxonomy}) => {
    const {authStore} = useStores();
    const [open, setOpen] = useState(false);
    if (!authStore.isMithraStaffGroup || !taxonomy) return null;

    return (
        <>
            <Tooltip title="Taxonomy settings">
                <IconButton aria-label="Taxonomy settings" onClick={() => setOpen(true)}>
                    <SettingsIcon width={20} height={20}/>
                </IconButton>
            </Tooltip>
            {open && <TaxonomySettingsDrawer taxonomy={taxonomy} onClose={() => setOpen(false)}/>}
        </>
    );
});
